import React from 'react';

const TextNote = ({ item }) => {
  return <div dangerouslySetInnerHTML={{ __html: item.question }}></div>;
};

export default TextNote;
